/*global p*/
import ReactGA from 'react-ga4'

/* 
Local: Handled in a .env file
Heroku: Handled in config vars 
*/
const __ga_code = process.env.REACT_APP_GOOGLE_ANALYTICS_CODE

// Log out info in development
const isBrowser = typeof window !== 'undefined'
const debug = isBrowser && window.location.hostname === 'localhost'

export const setGoogleAnalyticsEnvironment = function(page = '') {
	if (!__ga_code || __ga_code === '') return

	// Initialize Google Analytics
	if (debug) console.log('initialize', __ga_code)
	ReactGA.initialize(__ga_code)

	// Set first page view
	// if (page !== "") {
	// 	if (debug) console.log("pageview", page);
	// 	ReactGA.ga("send", "pageview", page);
	// }
}

export const addImpression = function(product) {
	if (__ga_code === '') return

	// ga('ec:addImpression', {           // Provide product details in an impressionFieldObject.
	// 	'id': 'P12345',                   // Product ID (string).
	// 	'name': 'Android Warhol T-Shirt', // Product name (string).
	// 	'category': 'Apparel/T-Shirts',   // Product category (string).
	// 	'brand': 'Google',                // Product brand (string).
	// 	'variant': 'Black',               // Product variant (string).
	// 	'list': 'Search Results',         // Product list (string).
	// 	'position': 1,                    // Product position (number).
	// 	'dimension1': 'Member'            // Custom dimension (string).
	// });

	// console.log(product);

	// ReactGA.plugin.execute("ec", "addImpression", product);
	// ReactGA.plugin.execute("ec", "send");
	// ReactGA.plugin.execute("ec", "clear");

	// ReactGA.ga("ec:addImpression", product);
	// ReactGA.ga("send", "event", "catalog", "impression", { nonInteraction: true });
}

export const addProductView = function(product) {
	if (__ga_code === '') return

	if (debug) console.log('GA addProductView()', product)

	let itemObj = {
		item_id: product.id,
		item_name: product.name,
		item_category: product.category,
		price: product.price,
	}

	ReactGA.event('view_item', {
		category: 'ecommerce',
		action: 'view_item',
		currency: 'CAD',
		value: product.price,
		items: [itemObj],
	})
}

export const addToCart = function(product, price, qty, variantSelected) {
	if (__ga_code === '') return

	let itemObj = {
		item_id: product.id,
		item_name: product.name,
		quantity: qty,
		item_category: product.category,
	}

	if (!!variantSelected && !!variantSelected.sku) {
		itemObj.item_id = variantSelected.sku
	}

	if (debug) console.log('GA addToCart()', itemObj)

	ReactGA.event('add_to_cart', {
		category: 'ecommerce',
		action: 'add_to_cart',
		currency: 'CAD',
		value: price,
		items: [itemObj],
	})
}

export const removeFromCart = function(product) {
	if (__ga_code === '') return

	let itemObj = {
		item_id: product.sku,
		item_name: product.title,
		quantity: product.qty,
		// price: product.price,
		// discount: product.price - product.price_final,
	}

	if (!!product.variant && !!product.variant.sku) {
		itemObj.item_id = product.variant.sku
	}

	if (!!product.categories[0] && !!product.categories[0].title) {
		itemObj.item_category = product.categories[0].title
	}

	if (debug) console.log('GA removeFromCart()', product)

	ReactGA.event('remove_from_cart', {
		category: 'ecommerce',
		action: 'remove_from_cart',
		currency: 'CAD',
		value: product.total,
		items: [itemObj],
	})
}

// ===================================================================================
//	CHECKOUT
// ===================================================================================
export const checkoutSignIn = function(products) {
	if (__ga_code === '') return

	let total = 0
	let items = []

	for (let i = 0; i < products.length; i++) {
		let item = addProductToGA(products[i])

		total += products[i].price_final
		items.push(item)
	}

	// ReactGA.ga("ec:setAction", "checkout", { step: 1 });
	// ReactGA.ga("send", "pageView");

	if (debug) console.log('GA checkoutSignIn()', products)

	// ReactGA.plugin.execute("ec", "setAction", "checkout", { step: 1 });
	// // ReactGA.ga("send", "pageView", "");

	ReactGA.event('begin_checkout', {
		category: 'ecommerce',
		action: 'begin_checkout',
		currency: 'CAD',
		value: total,
		items: items,
	})
}

export const setCheckoutSectionActive = function(step) {
	if (__ga_code === '') return

	if (debug) console.log('GA setCheckoutSectionActive()', step)

	ReactGA.event('checkout_progress', {
		category: 'ecommerce',
		action: 'checkout_progress',
		value: step,
	})
}

export const setCheckoutSectionComplete = function(step, additionalData) {
	if (__ga_code === '') return

	var details = {
		step: step,
	}

	if (typeof additionalData !== 'undefined') {
		for (let key in additionalData) {
			if (p.hasOwnProperty(key)) {
				details.key = p.key
			}
		}
	}

	if (debug) console.log('GA setCheckoutSectionComplete()', step)

	ReactGA.event('checkout_option', {
		category: 'ecommerce',
		action: 'checkout_option',
		value: details,
	})

	// ReactGA.plugin.execute("ec", "setAction", "checkout_option", details);
	// ReactGA.plugin.execute("send", "event", "Checkout", "Option");
}

export const setTransaction = function(transactionData) {
	if (__ga_code === '') return

	// // Add products
	// for (let i = 0; i < products.length; i++) {
	// 	addProductToGA(products[i]);
	// }

	let items = []

	// Add transaction
	let transactionObj = {
		category: 'ecommerce',
		action: 'purchase',
		transaction_id: transactionData.invoiceid,
		affiliation: transactionData.cart.company,
		value: transactionData.total_charged,
		tax: transactionData.totaltax,
		shipping: transactionData.totalshipping.toLocaleString('en-US', {
			style: 'currency',
			currency: 'CAD',
		}),
	}

	// Get any coupons used
	let coupons = ''
	const itemKeys = Object.keys(transactionData.items)

	for (let i = 0; i < Object.keys(transactionData.items).length; i++) {
		if (transactionData.items[itemKeys[i]].is_coupon) {
			if (coupons !== '') coupons += '|'
			coupons += transactionData.items[itemKeys[i]].sku
		}
		//? Might not be proper format??
		let itemObj = {
			item_id: transactionData.items[itemKeys[i]].sku,
			item_name: transactionData.items[itemKeys[i]].name,
			quantity: transactionData.items[itemKeys[i]].qty,
			price: transactionData.items[itemKeys[i]].price,
			discount: transactionData.items[itemKeys[i]].is_coupon
				? transactionData.items[itemKeys[i]].total
				: 0,
		}

		items.push(itemObj)
	}
	if (coupons !== '') transactionObj.coupon = coupons

	transactionObj.items = items

	if (debug) console.log('GA setTransaction()', transactionData)

	ReactGA.event('purchase', transactionObj)
}

// ===================================================================================
//	Utility
// ===================================================================================
export const addProductToGA = function(product) {
	if (__ga_code === '') return

	let variant_title =
		typeof product.variant_title !== 'undefined' && product.variant_title !== ''
			? product.variant_title
			: ''

	return {
		id: product.sku,
		name: product.title,
		variant: variant_title,
		price: product.price_final,
		quantity: product.qty,
	}
}



// WEBPACK FOOTER //
// ./src/utils/google-analytics.js